export interface ResumeBriefingSections {
  objective: string
  confirmed_decisions: string
  current_state: string
  artifacts: string
  completed_work: string
  open_questions: string
  cautions: string
}

export interface ResumeBriefingResponse {
  available: boolean
  format_version: number
  updated_at: string | null
  sections: ResumeBriefingSections
}

const EMPTY_MARKERS = new Set(['none', 'none.', 'n/a', 'not available', 'not available.'])

export interface BriefingInlineSegment {
  text: string
  bold: boolean
}

export function briefingInlineSegments(value: string): BriefingInlineSegment[] {
  const segments: BriefingInlineSegment[] = []
  const emphasis = /\*\*([^*\n]+?)\*\*/g
  let cursor = 0
  let match: RegExpExecArray | null

  while ((match = emphasis.exec(value)) !== null) {
    if (match.index > cursor) {
      segments.push({ text: value.slice(cursor, match.index), bold: false })
    }
    segments.push({ text: match[1], bold: true })
    cursor = match.index + match[0].length
  }

  if (cursor < value.length) {
    segments.push({ text: value.slice(cursor), bold: false })
  }

  return segments.length ? segments : [{ text: value, bold: false }]
}

export function briefingItems(value: string, limit = 4): string[] {
  const items = value
    .split(/\n+/)
    .map(line => line.trim().replace(/^[-*]\s+/, '').replace(/^\d+[.)]\s+/, ''))
    .filter(line => line && !EMPTY_MARKERS.has(line.toLowerCase()))
  return items.slice(0, limit)
}

export function hasBriefingContent(briefing?: ResumeBriefingResponse | null): briefing is ResumeBriefingResponse {
  if (!briefing?.available || briefing.format_version < 2) return false
  return Object.values(briefing.sections).some(section => briefingItems(section, 1).length > 0)
}
